import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function ChatWidgetOpensPage() {
    return (
        <OnboardingBody title='Chat widget opens' statusText='Engagement report'>
            <p>
                Every visitor who opened the Chat Widget is counted here. Even if they open it more
                than once, they’ll only be counted once.
            </p>
            <p>
                A visitor may open the widget by clicking on a smart nudge or an action like “Call”
                on the engagement bar.
            </p>
        </OnboardingBody>
    );
}
